import * as React from 'react'
import { Helmet } from 'react-helmet-async'

import { ReactComponent as Icon } from '../../assets/images/svg/mission-svgrepo-com.svg'
import Accordion from '../../components/Accordion'

const MV = () => {
  const [expanded, setExpanded] = React.useState(false)

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }
  return (
    <div className='MV' id='mv'>
      <Helmet>
        <title>Mission & Vision | NEOVERA SURVEYING CORPORATION</title>
        <meta
          name="description"
          content="Mission: To provide exceptional inspection and testing services that ensure the quality and integrity of our customer's goods and shipments. Vision: To become the top surveying company globally, delivering reliable and standardized results."
        />
        <link rel="canonical" href="https://neoveracsc.com/#mv" />
      </Helmet>

      <h2 className='headingH2'>
        <Icon className='icon' />
        Mission and Vision
      </h2>
      <div className='MV__item'>
        <Accordion
          aria='panel1a-content'
          id='panel1a-header'
          title='Our Mission'
          summary="To provide exceptional inspection and testing services that ensure the quality and integrity of our customer's goods and shipments."
          expanded={expanded === 'panel1'}
          onChange={handleChange('panel1')}
        />
        <Accordion
          aria='panel2a-content'
          id='panel2a-header'
          title='Our Vision'
          summary='NEOVERA SURVEYING CORPORATION aims to build a reputable name and become the top surveying company, dominating the global market by delivering reliable and standardized results.'
          expanded={expanded === 'panel2'}
          onChange={handleChange('panel2')}
        />
      </div>
    </div>
  )
}

export default MV
